import type { Item } from '@/lib/types';

export function itemUrl(item: Pick<Item, 'id' | 'itemType'>): string {
  return item.itemType === 'card'
    ? `/cards/${item.id}`
    : `/relics/${item.id}`;
}
